function ManigliaIcon(props) {
  return (
    <svg
      // version='1.1'
      id='ManigliaIcon'
      xmlns='http://www.w3.org/2000/svg'
      // x='0px'
      // y='0px'
      viewBox='0 0 162.38 24.38'
      // style={{ fill: '#aaaaaa' }}
      {...props}
    >
      <path
        className='st0'
        style={{ fill: 'rgb(255, 255, 255)', stroke: '#cccccc', strokeWidth: 0.754, strokeMiterlimit: 10 }}
        d='M6.25,12c53.48,0,149.37,0,149.37,0'
      />
      <polygon
        className='st1'
        style={{ stroke: 'rgb(255, 255, 255)', strokeWidth: 0.3047, strokeMiterlimit: 10 }}
        points='73.4,10.09 79.53,3.96 85.66,10.09 '
      />
      <polygon
        className='st1'
        style={{ stroke: 'rgb(255, 255, 255)', strokeWidth: 0.3047, strokeMiterlimit: 10 }}
        points='85.66,13.91 79.53,20.04 73.4,13.91 '
      />
    </svg>
  )
}

export default ManigliaIcon
